import {Alert, Popover, Text, ThemeIcon} from '@mantine/core'
import {useDisclosure} from '@mantine/hooks'
import {IconAlertTriangle} from '@tabler/icons-react'

type Props = {
  variant?: 'box' | 'tooltip'
}

export const NoProjectWarning = ({variant = 'box'}: Props) => {
  const [opened, {close, open}] = useDisclosure(false)
  const text = 'Recommendations will only be generated, if a project is selected'

  if (variant === 'tooltip') {
    return (
      <Popover width={200} position='bottom' withArrow shadow='md' opened={opened}>
        <Popover.Target>
          <ThemeIcon size={'sm'} variant={'light'} onMouseOver={open} onMouseLeave={close} color={'orange'}>
            <IconAlertTriangle stroke={1} />
          </ThemeIcon>
        </Popover.Target>
        <Popover.Dropdown style={{pointerEvents: 'none'}}>
          <Text>{text}</Text>
        </Popover.Dropdown>
      </Popover>
    )
  }

  return (
    <Alert variant={'light'} color={'orange'} icon={<IconAlertTriangle stroke={1} />}>
      {text}
    </Alert>
  )
}
